// Datos de ofertas de un proyecto
export interface MarketPlaceOfferModel {
    id: number;
    project_id: number;
    name: string;
    amount: number;
    participation_id: number;
    status: Status;
    formalization_type: FormalizationType;
    adquisition_price: number;
    current_bids: number;
    date: string;
    closing_date: string;
    has_bids: boolean;
    participationId: number;
    is_own_offer?: boolean;
}

// Datos de Proyectos (se usa en lista de proyectos y detalles de proyecto)
export interface MarketPlaceProjectModel {
    id: number;
    name: string;
    location: string;
    power: number;
    type: number;
    technology: number;
    offers: MarketPlaceOfferModel[]; // lista de ofertas de un proyecto
    listOffersMarketPlace: MarketPlaceOfferModel[];
    end_util_date: string;
    start_date: string;
    global_profitability: number;
    price_capital: number;
    num?: number;
    slug?: string;
}

// Datos de puja (lista de pujas)
export interface MarketPlaceMyBidsModel {
    id: number;
    formalization_type: FormalizationType;
    status: BidStatus;
    offer_status: Status;
    offer_sold_status?: OfferSoldStatus;
    project_id: number;
    participation_id: number;
    project_name: string;
    project_technology: number;
    name: string;
    price: number;
    date: any;
    closing_date?: any;
    decision_due_date?: any;
    decision_due_date_msg?: any;
    external_waiting_documentation_due_date?: any;
    contract_buyer_date?: any;
    contract_seller_date?: any;
    contract_seller?: boolean;
    contract_buyer?: boolean;
    internal_waiting_sign_due_date?: any;
    signed_seller?: boolean;
    signed_buyer?: boolean;
    internal_waiting_payment_due_date?: any;
    payment_date?: any;
    ok_date?: any;
    ko_date?: any;
    ok_due_date?: any;
    ko_due_date?: any;
    offer_amount: number;
    adquisition_price: number;
    notification?: boolean;
}

export type BidStatus =
    'active' |
    'modified' |
    'deleted' |
    'won' |
    'lost';

export type StatesBid =
    'activeActive' |
    'activePendingAcceptation' |
    'lostNotSold' |
    'soldExternalWaitingContractsOne' |
    'soldExternalWaitingContractsTwo' |
    'soldExternalWaitingContractsKO' |
    'soldExternalContractsKO' |
    'soldExternalValidating' |
    'soldExternalOK' |
    'soldExternalKO' |
    'soldInternalWaitingSignBuyer' |
    'soldInternalWaitingSignSeller' |
    'soldInternalWaitingSignBuyerKO' |
    'soldInternalWaitingSignSellerKO' |
    'soldInternalWaitingPayment' |
    'soldInternalWaitingPaymentKO' |
    'soldInternalOK' |
    'soldInternalKO' |
    'soldInternalWaitingAdminKO'
    ;

export interface StateBid {
    state: StatesBid;
}

// Datos de oferta (lista de ofertas)
export interface MarketPlaceMyOffersModel {
    id: number;
    formalization_type: FormalizationType;
    status: Status;
    sold_status?: OfferSoldStatus;
    project_id: number;
    participation_id: number;
    project_name: string;
    project_technology: number;
    name: string;
    best_bid: number;
    date: any;
    closing_date: any;
    closing_date_msg?: any;
    decision_due_date: any;
    current_bids: number;
    adquisition_price: number;
    amount: number;
    signed_seller?: boolean;
    signed_buyer?: boolean;
    internal_waiting_sign_due_date?: any;
    internal_waiting_payment_due_date?: any;
    external_waiting_documentation_due_date?: any;
    ok_date?: any;
    ko_date?: any;
    contract_seller?: boolean;
    contract_buyer?: boolean;
    participation_init?: number;
    participation_end?: number;
    contract_seller_date?: any;
    contract_buyer_date?: any;
    payment_date?: any;
    notification?: boolean;
    bids?: any;
    tagName?: string;
}

export type StatesOffer =
    'activeActive' |
    'activePendingAcceptation' |
    'notSoldNoBids' |
    'notSold' |
    'internalSoldWaitingBuyerSign' |
    'internalSoldWaitingSellerSign' |
    'internalNotSoldWaitingSignKo' |
    'internalSoldWaitingPayment' |
    'internalSoldOk' |
    'internalSoldKo' |
    'externalSoldWaitingContractsContact' |
    'externalSoldWaitingContracts' |
    'externalSoldWaitingContractsKo' |
    'externalSoldValidating' |
    'externalSoldOk' |
    'externalSoldKo'
    ;

export interface StateOffer {
    state: StatesOffer;
}

export type Status =
    'active' |
    'pending_acceptation' |
    'deleted' |
    'sold' |
    'not_sold' |
    'not_finished';

export type OfferSoldStatus =
    'internal_waiting_sign' |
    'internal_waiting_payment' |
    'external_waiting_contracts' |
    'external_validating' |
    'ok' | 'ko';

export interface MarketPlaceContactModel {
    sellerMail: string;
    sellerPhone: number;
    sellerName: string;
    sellerSurname: string;
    buyerMail: string;
    buyerPhone: number;
    buyerName: string;
    buyerSurname: string;
}

export interface MarketPlaceBalanceWalletModel {
    wallet: string;
    credit: number;
    debit: number;
    balance: number;
    promotionalBalance: number;
    moneyOutBalance: number;
}

// paquete participacion de proyecto
export interface MarketPlaceStockPackageModel {
    id: number;
    type: number;
    stocks: number;
    description: string;
    date: string;
    participation_init: number;
    participation_end: number;
    has_offers: boolean;
    adquisition_price: number;
    participation_id: number;
    msDate?: number;
}

// para creacion de una puja se crean a partir de detalles de un proyecto MarketPlaceProjectModel
export interface MarketPlaceBidCreateModel {
    offer_id: number;
    project_id: number;
    name_project: string;
    technology_project: number;
    name_seller: string;
    amount: number;
    participation_id: number;
    status: string;
    formalization_type: FormalizationType;
    adquisition_price: number;
    current_bids: number;
    date: string;
    closing_date: string;
}

// datos que se envian para crear oferta
export interface MarketPlaceOfferCreateModel {
    projectId: number;
    amount: number;
    participation_init: number;
    participation_end: number;
    formalization_type: string;
    participation_id: number;
    closing_date: string;
}

export type FormalizationType =
    'internal' |
    'external';

export type AppRoutes =
    'portfolio' |
    'marketplace' |
    'my-bids' |
    'my-offers' |
    'list-projects' |
    'detail-project' |
    'contact-us';
